var DropdownItemAlignment;
(function (DropdownItemAlignment) {
    DropdownItemAlignment["RIGHT"] = "right";
    DropdownItemAlignment["LEFT"] = "left";
})(DropdownItemAlignment || (DropdownItemAlignment = {}));

export { DropdownItemAlignment as D };
